import "bootstrap"
import "./css/application.scss"
import "./controllers"
import "@fortawesome/fontawesome-free"
import "@fortawesome/fontawesome-free/js/all"
import Rails from '@rails/ujs';

Rails.start()